import styled, {css} from 'styled-components';

import {textCss} from '~atoms/Text';

export const Input = styled.input`
    ${textCss}
    appearance: none;
    border: none;
    padding: 0;
    margin: 0 8px;
    display: block;
    min-width: 0;
    background: none;
    color: #000000;
    flex: 1;

    &::placeholder {
        color: var(--gray-text);
    }

    &:focus {
        outline: none;
    }
`;

export const ClearBtn = styled.button`
    background: none;
    margin: 0;
    margin-right: 16px;
    padding: 0;
    border: 0;
    cursor: pointer;
    color: hsl(0, 0%, 58%);
`;

type FieldContainerProps = {
    withIcon: boolean;
    disabled?: boolean;
};

export const FieldContainer = styled.div<FieldContainerProps>`
    background: var(--gray-bg);
    border-radius: 16px;
    padding: 8px 4px;
    width: 100%;
    color: var(--gray-text);
    display: flex;
    align-items: center;
    cursor: text;
    position: relative;

    ${({disabled}) =>
        disabled &&
        css`
            opacity: 0.5;

            &,
            & > * {
                cursor: not-allowed;
            }
        `}

    svg:first-child {
        pointer-events: none;
    }

    ${({withIcon}) =>
        withIcon &&
        css`
            padding-left: 16px;
        `}

    ${Input}:placeholder-shown + ${ClearBtn} {
        opacity: 0;
        pointer-events: none;
    }
`;
